import { Alert, Link, Stack, Typography, type TypographyProps } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { type CustomerService } from "@/features/customer-service"
import { NextIntlRichText } from "@/features/translations"
import { useTypeformError } from "@/hooks/useTypeformError"

type ErrorMessageProps = {
    errorMessage: string
    customerServiceMessage?: string
    customerService?: CustomerService
} & TypographyProps

export function ErrorMessageAlert({
    errorMessage,
    customerServiceMessage,
    customerService = "octopus",
    ...props
}: ErrorMessageProps) {
    const t = useTranslations("ErrorMessageAlert")
    const { isTypeformError, typeformUrl } = useTypeformError({
        errorMessage,
    })

    return (
        <Alert severity="error">
            <Typography
                color="inherit"
                textStyle="h4"
                {...props}
            >
                {t("default")}
            </Typography>
            <Stack flexDirection="column">
                <Typography color="inherit">{errorMessage}</Typography>
                <Typography
                    color="inherit"
                    wordBreak="break-word"
                    textAlign="start"
                >
                    {customerServiceMessage || t("customerService")}{" "}
                    <NextIntlRichText customerService={customerService}>
                        {(tags) =>
                            isTypeformError
                                ? t.rich("customerServiceContactWithTypeform", {
                                      ...tags,
                                      TypeformLink: (chunks) => (
                                          <Link href={typeformUrl}>{chunks}</Link>
                                      ),
                                  })
                                : t.rich("customerServiceContact", tags)
                        }
                    </NextIntlRichText>
                </Typography>
            </Stack>
        </Alert>
    )
}

ErrorMessageAlert.messages = ["ErrorMessageAlert"] as const
